import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/calendar-range.vue
var o = {
	name: "DtIconCalendarRange",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--calendar-range"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Calendar Range",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M4 .5a.5.5 0 0 1 .5.5v.5h3V1a.5.5 0 0 1 1 0v.5h1A1.5 1.5 0 0 1 11 3v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 1 10V3a1.5 1.5 0 0 1 1.5-1.5h1V1A.5.5 0 0 1 4 .5Zm-.5 2h-1A.5.5 0 0 0 2 3v1.5h8V3a.5.5 0 0 0-.5-.5h-1V3a.5.5 0 0 1-1 0v-.5h-3V3a.5.5 0 0 1-1 0v-.5Zm6.5 3H2V10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V5.5ZM3 7a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H3.5A.5.5 0 0 1 3 7Zm2 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 5 7ZM3 9a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 3 9Zm5 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H8.5A.5.5 0 0 1 8 9Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=calendar-range.js.map